<template>
	<div :style="{ width: '100%' }">
		<v-card-title>
			{{ $vuetify.lang.t("$vuetify.views.tasks.addNewTask.header") }}
		</v-card-title>

		<v-card-text class="pb-4">
			<v-row>
				<v-col lg="12">
					<div class="d-flex flex-row align-center">
						<avatar :hideActivity="true" class="mr-5" />

						<v-text-field
							@keydown.enter.prevent="addTask()"
							v-model="taskTitle"
							outlined
							elevation="0"
							:placeholder="
								$vuetify.lang.t(
									'$vuetify.views.tasks.addNewTask.startTyping'
								)
							"
							hide-details
							auto-grow
							dense
						></v-text-field>
					</div>
				</v-col>
			</v-row>

			<v-row class="ma-0 pa-0 px-3 pt-4 mt-0" align="center">
				<v-spacer></v-spacer>
				<v-btn
					@click="openTaskDialog()"
					height="40"
					color="lighten2"
					elevation="0"
				>
					<advanced-add class="mr-1" />
					{{
						$vuetify.lang.t(
							"$vuetify.views.tasks.addNewTask.buttons.advancedAdd"
						)
					}}
				</v-btn>

				<div class="mx-2"></div>

				<v-btn
					@click="addTask()"
					:loading="loading"
					height="40"
					color="primary"
					elevation="0"
				>
					<v-icon class="mr-1">$plus</v-icon>
					{{
						$vuetify.lang.t(
							"$vuetify.views.tasks.addNewTask.buttons.add"
						)
					}}
				</v-btn>
			</v-row>
		</v-card-text>

		<task-add-dialog
			:key="dialog + user.id"
			type="add"
			:taskTitle="taskTitle"
			@closeDialog="closeTaskDialog()"
			@addTask="addTask($event)"
			:dialog="dialog"
		/>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";

import AdvancedAdd from "@/components/icons/AdvancedAdd";
import TaskAddDialog from "@/components/tasks/dialogs/TaskAddDialog";
import Avatar from "@/components/Avatar";

export default {
	components: {
		AdvancedAdd,
		TaskAddDialog,
		Avatar,
	},
	data() {
		return {
			dialog: false,
			taskTitle: "",
			loading: false,
		};
	},
	computed: {
		...mapGetters({
			user: "auth/user",
		}),
		today() {
			return this.$moment().parseZone().format("YYYY-MM-DD HH:mm:ss");
		},
		tomorrow() {
			return this.$moment(this.today)
				.add(1, "days")
				.parseZone()
				.format("YYYY-MM-DD HH:mm:ss");
		},
		thisWeek() {
			return this.$moment()
				.endOf("week")
				.parseZone()
				.format("YYYY-MM-DD HH:mm:ss");
		},
	},
	methods: {
		...mapActions("tasks", ["postTask"]),

		openTaskDialog() {
			this.dialog = true;
		},
		closeTaskDialog() {
			this.dialog = false;
		},
		async addTask(params) {
			this.loading = true;
			let parametrs = params ? params.params : null;
			if (this.taskTitle && !params) {
				const task_list_id =
					this.$store.state.tasks.view.name === "list"
						? this.$store.state.tasks.view.id
						: null;
				const tags =
					this.$store.state.tasks.view.name === "tag"
						? this.$store.state.tasks.view.id
						: null;

				let deadline;
				if (this.$store.state.tasks.view.name === "today") {
					deadline = this.today;
				} else if (this.$store.state.tasks.view.name === "tomorrow") {
					deadline = this.tomorrow;
				} else if (this.$store.state.tasks.view.name === "this_week") {
					deadline = this.thisWeek;
				}

				parametrs = {
					user_id: this.user.id,
					title: this.taskTitle,
					status: "unfinished",
					task_list_id: task_list_id,
					tags: tags ? [tags] : null,
					deadline: deadline || null,
				};
			} else if (params && params.params) {
				parametrs = params.params;
			}

			if (parametrs) {
				const res = await this.postTask(parametrs);
				this.taskTitle = "";

				if (params) {
					if (params.taskItems) {
						params.taskItems.forEach((item) => {
							this.postTaskItem(item, res.taskID);
						});
					}
				}
			}

			this.loading = false;
		},

		async postTaskItem(item, id) {
			await axios
				.post("task-items", {
					task_id: id,
					name: item.name,
					is_finished: item.is_finished,
				})
				.then(() => {})
				.catch((error) => {
					console.log("POST TASK ITEMS ERROR", error);
				});
		},
	},
};
</script>

<style lang="scss">
.add-task-input {
	textarea {
		margin: 16px 4px 12px !important;
	}
}
</style>
